const state = {
  styleName: "convention",
};

const mutations = {
  Commit_StyleName(state, styleName) {
    state.styleName = styleName;
  },
};

const actions = {
  setStyleName({ commit }, styleName) {    
    commit("Commit_StyleName", styleName);
  },
};

const getters = {
  itemCount: (state) => state.styleName.length,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
